import _ from 'lodash';
import { roleIdE, roleWeight, loginRoleWeight } from '../comm/RoleMap';
import { LOGIN_INFO } from '../comm/constant';
import { getUserInfo } from '.';

let userRoleTypeId = -1;

const P = {
  roleName: 'roleName',
  roleType: 'roleTypeId',
  wardId: 'wardId',
  hospId: 'hospId',
  hospName: 'hospName',
  wardName: 'wardName',
  funcs: 'funcs',
  moduleCode: 'moduleCode',
  functionType: 'functionType',
  functionId: 'functionId',
  wards: 'wards',
  userId: 'userId',
  roleId: 'roleId',
  staffName: 'staffName',
  corpId: 'corpId',
  hospitalName: 'hospitalName',
  status: 'status',
  hospCode: 'hospCode',
};

const userRoleHasAdmission = [
  'Hospital Administrator',
  'Delegated Ward IC',
  'Ward IC',
  'Nurse',
  'Clerk',
  'CC Power User',
  'CC Ward User',
];

const wardMenuE = {
  bedStatusYn: 'bedStatusYn',
  dutyAssignYn: 'dutyAssignYn',
  ehandOverYn: 'ehandOverYn',
  equipmentYn: 'equipmentYn',
  drivePath: 'drivePath',
  televisitYn: 'televisitYn',
  admissionYn: 'admissionYn',
  patSurveyYn: 'patSurveyYn',
};

const userRoleList = {
  setGlobalUserRoleTypeId: function (allData, hospId, wardId, userId) {
    if (Array.isArray(allData)) {
      userRoleTypeId = this.getRoleType(allData, hospId, wardId, userId) ?? -1;
    } else {
      userRoleTypeId = allData;
    }
  },
  getGlobalUserRoleTypeId: function () {
    return userRoleTypeId;
  },
  getHospWardFuncs: function (allData, hospId, wardId, userId) {
    const hospWard = this.getHospWard(allData, hospId, wardId, userId);
    return hospWard ? hospWard[P.funcs] : null;
  },
  // getHospAllWard: function (allData, hospId, wardId, userId) {
  //   const hospWard = this.getHospWard(allData, hospId, wardId, userId);
  //   return hospWard ? hospWard[P.wards] : null;
  // },
  filterInActive: function (allData) {
    return _.filter(allData, (item) => {
      return Boolean(item?.[P.status]);
    });
  },
  filterHospIdAndWardId: function (allData, hospId, wardId) {
    return _.filter(allData, (item) => {
      return (
        item[P.hospId] === hospId &&
        _.find(item[P.wards], (wardItem) => {
          return wardItem[P.wardId] === wardId;
        })
      );
    });
  },
  getMaxRoleUseHospIdAndWardId: function (allData, hospId, wardId) {
    const filterHospIdAndWardId = this.filterHospIdAndWardId(allData, hospId, wardId);
    if (!Array.isArray(filterHospIdAndWardId) || filterHospIdAndWardId.length === 0) {
      return null;
    }
    return this.maxLoginRole(filterHospIdAndWardId);
  },
  getAllHospWardFormat: function (allData, hospId, wardId) {
    const result = [];
    _.forEach(allData, (hospItem) => {
      _.forEach(hospItem?.[P.wards], (wardItem) => {
        result.push({
          hospitalId: hospItem[P.hospId],
          hospitalName: hospItem[P.hospName],
          wardId: wardItem[P.wardId],
          wardName: wardItem[P.wardName],
          userId: hospItem[P.userId],
          roleId: hospItem[P.roleId],
        });
      });
    });
    return result;
  },
  getHospWardFormatUseRoleIdAndWardId: function (allData, roleId, wardId) {
    let result = null;
    const allHosp = this.getAllHospUseRoleId(allData, roleId);
    _.some(allHosp, (hospItem) => {
      _.some(hospItem?.[P.wards], (wardItem) => {
        if (wardItem[P.wardId] === wardId) {
          result = {
            hospitalId: hospItem[P.hospId],
            hospitalName: hospItem[P.hospName],
            wardId: wardItem[P.wardId],
            wardName: wardItem[P.wardName],
            userId: hospItem[P.userId],
            roleId: hospItem[P.roleId],
          };
        }
        return Boolean(result);
      });
      return Boolean(result);
    });
    return result;
  },
  getAllRoleNameFormat: function (allData) {
    const result = {};
    _.forEach(allData, (item) => {
      result[item[P.roleId]] = { text: item[P.roleName], value: item[P.roleId] };
    });
    return Object.values(result);
  },
  getAllHospUseRoleId: function (allData, roleId) {
    return _.filter(allData, (item) => item[P.roleId] === roleId);
  },

  getHospAllWardFormatUseRoleId: function (allData, roleId) {
    const result = [];
    const allHosp = this.getAllHospUseRoleId(allData, roleId);
    _.forEach(allHosp, (hospItem) => {
      return _.forEach(hospItem?.[P.wards], (wardItem) => {
        result.push({ text: wardItem[P.wardName], value: wardItem[P.wardId] });
      });
    });
    return _.sortBy(result, ['text']);
  },

  getAllHospWardId: function (allData) {
    const result = [];
    _.forEach(allData, (hospItem) => {
      _.forEach(hospItem?.[P.wards], (wardItem) => {
        result.push(wardItem[P.wardId]);
      });
    });
    return result;
  },
  getHospWard: function (allData, hospId, wardId, userId) {
    return allData
      ? allData.find((item) => {
          if (item[P.userId]) {
            return item[P.userId] === userId;
          } else {
            return item[P.hospId] === hospId;
          }
        })
      : null;
  },
  filterHospWardUseHospId: function (allData, hospId) {
    return allData
      ? allData.filter((item) => {
          return item[P.hospId] === hospId;
        })
      : null;
  },
  getRoleNameUseUserId: function (allData, userId) {
    const hospWard = this.getHospWard(allData, null, null, userId);
    return hospWard ? hospWard[P.roleName] : null;
  },

  getAllHospitalId: function (allData) {
    return _.map(allData, (item) => {
      return item[P.hospId];
    });
  },

  isSuperAdmin: function (allData, hospId, wardId, userId) {
    if (arguments.length === 1) {
      return allData
        ? Boolean(
            allData.find((item) => {
              return item[P.roleType] === roleIdE.SA;
            })
          )
        : false;
    } else {
      const hospward = this.getHospWard(allData, hospId, wardId, userId);
      return userRoleFunc.isSuperAdmin(hospward);
    }
  },
  isHospitalAdmin: function (allData, hospId, wardId, userId) {
    const hospward = this.getHospWard(allData, hospId, wardId, userId);
    return userRoleFunc.isHospitalAdmin(hospward);
  },
  isLoginUseGlobleTypeId: function () {
    return userRoleList.getGlobalUserRoleTypeId() > -1;
  },
  isHospitalAdminUseGlobleTypeId: function () {
    return userRoleList.getGlobalUserRoleTypeId() === roleIdE.HA;
  },
  isSuperAdminUseGlobleTypeId: function () {
    return userRoleList.getGlobalUserRoleTypeId() === roleIdE.SA;
  },
  isProAdminUseGlobleTypeId: function () {
    return userRoleList.getGlobalUserRoleTypeId() === roleIdE.PRO;
  },
  isSAorHAUseGlobleTypeId: function () {
    return (
      this.isHospitalAdminUseGlobleTypeId() || this.isSuperAdminUseGlobleTypeId() || this.isProAdminUseGlobleTypeId()
    );
  },
  isWardAdmin: function (allData, hospId, wardId, userId) {
    const hospward = this.getHospWard(allData, hospId, wardId, userId);
    return userRoleFunc.isWardAdmin(hospward);
  },
  isWardIc: function (allData, hospId, wardId, userId) {
    const hospward = this.getHospWard(allData, hospId, wardId, userId);
    return userRoleFunc.isWardIc(hospward);
  },
  // getFuncModuleCodes: function (allData, hospId, wardId, userId) {
  //   const hospWardFuncs = this.getHospWardFuncs(allData, hospId, wardId, userId);
  //   return hospWardFuncs
  //     ? [
  //         ...new Set(
  //           hospWardFuncs.map((item) => {
  //             return item[P.moduleCode];
  //           })
  //         ),
  //       ]
  //     : null;
  // },
  maxRole: function (allData) {
    let max = null;
    if (Array.isArray(allData)) {
      max = allData[0];
      for (let i = 1; i < allData.length; i++) {
        if (roleWeight[allData[i][P.roleType]] > roleWeight[max[P.roleType]]) {
          max = allData[i];
        }
      }
      return max;
    }
    return max;
  },
  maxLoginRole: function (allData) {
    let max = null;
    if (Array.isArray(allData)) {
      max = allData[0];
      for (let i = 1; i < allData.length; i++) {
        if ((loginRoleWeight?.[allData[i][P.roleId]] ?? 0) > (loginRoleWeight?.[max[P.roleId]] ?? 0)) {
          max = allData[i];
        }
      }
      return max;
    }
    return max;
  },
  getmaxRoleType: function (allData) {
    const maxRole = this.maxRole(allData);
    return maxRole ? maxRole[P.roleType] : null;
  },
  getMaxRoleFunc: function (allData) {
    const maxRole = this.maxRole(allData);
    return maxRole ? maxRole[P.funcs] : null;
  },
  getModuleCodes: function (allData) {
    const maxRoleFunc = this.getMaxRoleFunc(allData);
    return maxRoleFunc
      ? [
          ...new Set(
            maxRoleFunc.map((item) => {
              return item[P.moduleCode];
            })
          ),
        ]
      : null;
  },
  getRoleType: function (allData, hospId, wardId, userId) {
    const hospWard = this.getHospWard(allData, hospId, wardId, userId);
    return hospWard ? hospWard[P.roleType] : null;
  },
  getRoleId: function (allData, userId) {
    const hospWard = this.getHospWard(allData, null, null, userId);
    return hospWard ? hospWard[P.roleId] : null;
  },
  getAllRoleTypeList: function (allData) {
    return allData
      ? allData.map((item) => {
          return item[P.roleType];
        })
      : null;
  },
  // getFuncModuleCodeActions: function (allData, hospId, wardId, userId) {
  //   const funcModuleCodes = this.getHospWardFuncs(allData, hospId, wardId, userId);
  //   return funcModuleCodes
  //     ? funcModuleCodes.filter((item) => {
  //         return item[P.functionType] === functionTypeE.function;
  //       })
  //     : null;
  // },
  // getFuncModuleCodeActionIds: function (allData, hospId, wardId, userId) {
  //   const funcModuleCodeActions = this.getFuncModuleCodeActions(allData, hospId, wardId, userId);
  //   return funcModuleCodeActions
  //     ? funcModuleCodeActions.map((item) => {
  //         return item[P.functionId];
  //       })
  //     : null;
  // },
  adminChangeHandle: function (allData, hospId, wardId, userId, obj) {
    if (this.isSuperAdmin(allData, hospId, wardId, userId)) {
      return obj?.super?.();
    } else if (this.isHospitalAdmin(allData, hospId, wardId, userId)) {
      return obj?.hospital?.();
    } else if (this.isWardAdmin(allData, hospId, wardId, userId)) {
      return obj?.ward?.();
    } else {
      return obj?.other?.();
    }
  },
  isAdmin: function (allData, hospId, wardId, userId) {
    const hospward = this.getHospWard(allData, hospId, wardId, userId);
    return userRoleFunc.isAdmin(hospward);
  },
  // isWardEmpty: function (allData, hospId, wardId, userId) {
  //   const hospward = this.getHospWard(allData, hospId, wardId, userId);
  //   return userRoleFunc.isWardEmpty(hospward);
  // },
  hospWardListDrapformat: function (allData) {
    const result = {};
    const wardIds = {};
    _.forEach(allData, (item) => {
      const hId = item[P.hospId];
      if (!result[hId]) {
        result[hId] = {
          hospitalId: hId,
          hospitalName: item[P.hospName],
          hospCode: item[P.hospCode],
          wards: item[P.wards].filter((item) => {
            wardIds[item[P.wardId]] = true;
            return true;
          }),
        };
      } else {
        result[hId] = {
          ...result[hId],
          hospCode: item[P.hospCode],
          wards: [
            ...result[hId][P.wards],
            ...item[P.wards].filter((item) => {
              const wardId = item[P.wardId];
              const result = wardIds[wardId];
              wardIds[wardId] = true;
              return !result;
            }),
          ],
        };
      }
    });
    return Object.values(result);
  },

  getDetailFormat: function (allData, hospId, wardId, userId) {
    const hospWard = this.getHospWard(allData, hospId, wardId, userId);
    return userRoleFunc.getDetailFormat(hospWard, wardId);
  },
};

const userRoleFunc = {
  getRoleFunc: (allData) => {
    return allData ? allData[P.funcs] : null;
  },
  getWards: (allData) => {
    return allData ? allData[P.wards] : null;
  },
  getWardMenus: function (allData, wardId) {
    const result = {};
    const ward = _.find(this.getWards(allData), (item) => {
      return item[P.wardId] === wardId;
    });
    if (!ward) {
      Object.keys(wardMenuE).forEach((item) => {
        result[item] = false;
      });
    } else {
      Object.keys(wardMenuE).forEach((item) => {
        if (item === 'drivePath') {
          result[item] = ward[item] !== null;
        }
        result[item] = Boolean(ward[item]);
      });
    }
    return result;
  },
  getModuleCodes: function (allData) {
    const roleFunc = this.getRoleFunc(allData);
    return roleFunc
      ? [
          ...new Set(
            roleFunc.map((item) => {
              return item[P.moduleCode];
            })
          ),
        ]
      : null;
  },
  isAdmin: function (allData) {
    const admins = [roleIdE.SA, roleIdE.HA, roleIdE.WA];
    return allData ? admins.includes(allData[P.roleType]) : false;
  },
  isSuperAdmin: function (allData) {
    return allData ? roleIdE.SA === allData[P.roleType] : false;
  },
  isHospitalAdmin: function (allData) {
    return allData ? roleIdE.HA === allData[P.roleType] : false;
  },
  isWardAdmin: function (allData) {
    return allData ? roleIdE.WA === allData[P.roleType] : false;
  },
  isHospitalAdminAndWardAdmin: function (allData) {
    const admin = [roleIdE.HA, roleIdE.WA];
    return allData ? admin.includes(userRoleFunc.getRoleType(allData)) : false;
  },
  isWardEmpty: function (allData) {
    const wards = this.getWards(allData);
    return wards ? wards.length === 0 : true;
  },
  getHospitalId: function (allData) {
    return allData ? allData[P.hospId] : null;
  },
  getHospitalName: function (allData) {
    return allData ? allData[P.hospName] : null;
  },
  getRoleType: function (allData) {
    return allData ? allData[P.roleType] : null;
  },
  getRoleTypeName: function (allData) {
    return allData ? allData[P.roleName] : null;
  },
  getWardName: function (allData, wardId) {
    return (
      _.find(allData?.[P.wards], (item) => {
        return item.wardId === wardId;
      })?.[P.wardName] ?? null
    );
  },
  getRoleId: function (allData) {
    return allData ? allData[P.roleId] : null;
  },
  getCorpId: function (allData) {
    return allData ? allData[P.corpId] : null;
  },
  getStaffName: function (allData) {
    return allData ? allData[P.staffName] : null;
  },
  getHospCode: function (allData) {
    return allData ? allData[P.hospCode] : null;
  },
  getDetailFormat: function (allData, wardId) {
    return {
      [P.roleType]: this.getRoleType(allData),
      [P.roleName]: this.getRoleTypeName(allData),
      [P.roleId]: this.getRoleId(allData),
      [P.wardId]: wardId,
      [P.wardName]: this.getWardName(allData, wardId),
      [P.hospId]: this.getHospitalId(allData),
      [P.hospitalName]: this.getHospitalName(allData),
      [P.corpId]: this.getCorpId(allData),
      [P.staffName]: this.getStaffName(allData),
      [P.hospCode]: this.getHospCode(allData),
    };
  },
  isExistWard: function (allData) {
    return allData ? allData[P.wards]?.length > 0 : false;
  },
  getFirstWardName: function (allData) {
    return allData ? allData[P.wards]?.[0]?.[P.wardName] : null;
  },
  getFirstWardId: function (allData) {
    return allData ? allData[P.wards]?.[0]?.[P.wardId] : null;
  },
  updateLoginInfo: function (allData) {
    try {
      let localLoginInfo = JSON.parse(localStorage.getItem(LOGIN_INFO));
      const detailFormat = this.getDetailFormat(allData, localLoginInfo.wardId);
      if (detailFormat.wardName === null || detailFormat.wardName === undefined || !this.isExistWard(allData)) {
        localLoginInfo = {
          ...localLoginInfo,
          hospitalId: detailFormat[P.hospId],
          hospitalName: detailFormat[P.hospitalName],
          wardId: this.getFirstWardId(allData),
          wardName: this.getFirstWardName(allData),
          corpID: detailFormat[P.corpId],
        };
      }
      return localLoginInfo;
    } catch {}
  },
  isWardIc: function (allData) {
    return this.getRoleType(allData) === roleIdE.WA;
  },
  getIsShowAdmission: function () {
    const roleName = getUserInfo()?.roleName ?? null;
    // logout的状态也要能看到
    const localLoginInfo = JSON.parse(localStorage.getItem(LOGIN_INFO));
    return userRoleHasAdmission.includes(roleName) || !localLoginInfo?.flag;
  },
};

export { userRoleList, userRoleFunc, P as roleObjKey, wardMenuE };
